import { compositeReportStatus, getStudentAssessment } from "@/lib/report-data";
import type { Student, TermId } from "@/types";

export interface OverallScorePoint {
  studentId: string;
  studentName: string;
  percentile: number;
  displayPercentile: number;
}

export function overallScorePointsForTerm(students: Student[], termId: TermId | string): OverallScorePoint[] {
  return students
    .map((student) => {
      const assessment = getStudentAssessment(student, termId);
      if (compositeReportStatus(assessment) === "suppressed") return null;
      const percentile = assessment.overallPercentile;
      if (percentile == null) return null;
      return {
        studentId: student.id,
        studentName: student.name,
        percentile,
        displayPercentile: Math.round(percentile),
      };
    })
    .filter((point): point is OverallScorePoint => point != null)
    .sort((a, b) => a.percentile - b.percentile || a.studentName.localeCompare(b.studentName) || a.studentId.localeCompare(b.studentId));
}
